"use strict";

import angular from "angular";
import _ from "lodash";

import * as LayoutConfigModels from "./layout-configs";

export class LayoutService {
    headerConfig = {
        enabled: true,
        logoPro: { enabled: true },
        homeIcon: { enabled: false },
        avatar: { enabled: false },
        title: { enabled: false, text: "" },
        moduleTitle: { enabled: false, text: "", description: "" },
        searchInput: {
            enabled: false,
            placeholder: ""
        },
        nanda: { enabled: false },
        helpCentral: { enabled: true },
        featureNews: { enabled: true },
        profileMenu: { enabled: true },
        closeTimes: { enabled: false }
    };

    sidebarConfig = { enabled: true };

    alertNotification = { enabled: false };

    constructor() {}

    $onInit() {}

    setAppLayout(layoutConfig) {
        this.resetModuleTitle();

        if (!layoutConfig) return false;

        const layoutConfigModel = angular.copy(
            LayoutConfigModels[layoutConfig.model] || {}
        );

        if (layoutConfig.ignore)
            _.unset(
                layoutConfigModel[layoutConfig.ignore.object],
                layoutConfig.ignore.path
            );

        this.headerConfig = {
            ...this.headerConfig,
            ...layoutConfigModel.headerConfig
        };

        this.sidebarConfig = {
            ...this.sidebarConfig,
            ...layoutConfigModel.sidebarConfig
        };

        this.setAttrs(layoutConfig.setAttrs);
    }

    resetModuleTitle() {
        this.headerConfig.moduleTitle = {
            enabled: false,
            text: "",
            description: ""
        };
    }

    setAttrs(attrs = []) {
        if (!attrs.length) return;
        for (const attr of attrs) {
            _.set(this[attr.object], attr.path, attr.value);
        }
    }
}

angular.module("nucont.shared").service("LayoutService", [LayoutService]);
